// removed by extract-text-webpack-plugin
module.exports = {"Topbread":"index__Topbread__1x_5l","createBtn":"index__createBtn__3HOm0","pageTop":"index__pageTop__2YBal","pageTitle":"index__pageTitle__88OEc","removebtn":"index__removebtn__1yEiw","cardList":"index__cardList__zSjst","card":"index__card__2_ElH","item":"index__item__2r7iy","extraImg":"index__extraImg__1CUYI","_list_link_to":"index___list_link_to__7f5Cd","newButton":"index__newButton__o4TOR","cardAvatar":"index__cardAvatar__3lese","cardDescription":"index__cardDescription__3Xisg","pageHeaderContent":"index__pageHeaderContent__1vbRJ","contentLink":"index__contentLink__1oc9F"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Products/Remove/index.less
// module id = 1343
// module chunks = 0